import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';
import { AppNavigationService } from '../app-navigation.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { ErrorHandlerModuleService } from 'r2-error-handler-module';
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  private entityType;

  private isSinglePaymentEftPlan: boolean;

  constructor(private service: AppNavigationService, private cookieService: CookieService,
    private router: Router, private errorHandlerService: ErrorHandlerModuleService) { }


  intercept(request: HttpRequest<any> | HttpResponse<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request instanceof HttpResponse) {
      return of();
    }
    return this.httpRequest(request, next);
  }

  httpRequest(request: HttpRequest<any>, next: HttpHandler) {
    const token: string = sessionStorage.getItem('mmih_auth_token');
    if (!request.url.includes('slack.com')) {
      if (token) {
        if (!request.headers.get('Authorization') && token) {
          request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        } else if (!request.headers.get('Authorization') && !token) {
          this.errorHandlerService.openErrorSnackBar('Login expired. Please login again', 1000);
          this.service.redirectToMethub();
        }
      }
    }
    return next.handle(request).pipe(
      switchMap((response: HttpEvent<any>) => {
        if (response instanceof HttpResponse) {
          this.activateNext(request, response);
        }
        return of(response);
      })
    );
  }

  activateNext(request: HttpRequest<any>, response: HttpResponse<any>) {
    const planId = JSON.parse(this.cookieService.get('plan')).id;
    const appName = JSON.parse(this.cookieService.get('appType')).appName;
    const api = this.cookieService.get('api_version');
    const agreementsUrl = `/life-goal-domain/${appName}/${api}/agreement/${planId}`;
    if (this.router.url === '/payment') {
      const url = '/' + appName + '/' + api + '/consent/' + planId;
      if (response.status === 200 && response.url.includes(agreementsUrl)) {
        // Allow to skip the payments page for single payment plans (EFT only)
        let skipPaymentsForEftSingles = false;
        response.body.forEach((agreement) => {
          skipPaymentsForEftSingles = (
            agreement && agreement.agreementType === 'longTerm' &&
            agreement.premium && agreement.premium.frequency === 'single'
          );
        });
        if (skipPaymentsForEftSingles) {
          this.service.setCanGoNext(true);
        }
      } else if (response.status === 200 && response.url.includes(url)) {
        this.service.setCanGoNext(true);
      } else if (response.status === 200 && response.url.includes('restapi/v1/bank_account/')) {
        this.service.setCanGoNext(true);
      } else if (response.status === 200 && response.url.includes('payment/bankAccount/')) {
        this.service.setCanGoNext(true);
      } else if (response.status === 200 && response.url.includes('/stop-orders-manager/v1/agencydetails/')) {
        this.service.setCanGoNext(true);
      } else if (response.status === 200 && response.url.includes('/form/v1/update')) {
        this.service.setCanGoNext(false);
      }
    } else if (this.router.url === '/planOwner') {
      if (response.status === 200 && response.url.includes('/MMISharedServices/red-flag-match')) {
        request.body.entities.forEach(entity => {
          if (entity.type === 'BANK_ACCOUNT') {
            this.entityType = entity.type;
          }
        });
        if (!this.entityType) {
          this.service.setCanGoNext(true);
        }
      } else if (this.entityType && response.status === 200 && response.body && response.body.result !== 'Failed' && response.url.includes('/bank/verify')) {
        this.service.setCanGoNext(true);
      }
    } else if (this.router.url === '/peopleOnYourPlan') {
      const url = '/' + appName + '/' + api + '/beneficiary/' + planId;
      if (response.status === 200 && response.url.includes(url)) {
        this.service.setCanGoNext(true);
      }
    } else if (this.router.url === '/declaration') {
      const url = '/' + appName + '/' + api + '/consent/' + planId;
      if (response.status === 200 && response.url.includes(url)) {
        if (request.body && request.body.consentResponse === 'ACCEPT') {
          this.service.setCanGoNext(true);
        } else if (response.body && response.body.length && response.body[0].consentResponse && response.body[0].consentResponse === 'ACCEPT') {
          this.service.setCanGoNext(true);
        }
      }
    } else if (this.router.url === '/adviser') {
      this.service.setCanGoNext(false);
      if (response.status === 200 && response.url.includes(agreementsUrl)) {
        response.body.forEach((agreement) => {
          this.isSinglePaymentEftPlan = (
            agreement && agreement.agreementType === 'longTerm' &&
            agreement.premium && agreement.premium.frequency === 'single'
          );
        });
      }
      if (response.status === 200 && response.url.includes('/performRiskAssessment')) {
        if (response.body.riskOutcomeCode !== 'REJ') {
          this.service.setCanGoNext(true);
        }
      } else if (response.status === 200 && response.url.includes('/managerApproval/')) {
        response.body.engineResult = 'ACCEPT';
        if (response && response.body && response.body.engineResult && response.body.engineResult !== 'REJECT') {
          this.service.setCanGoNext(true);
        }
        // Manager approval is called, so now we can show the next button for single payment frequency plans
        if (this.isSinglePaymentEftPlan) {
          this.service.setCanGoNext(true);
        }
      }
    }
  }
}
